import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatTseDate } from '../../../../../../helper/formatTseDate'
import { TseErstbestellungBlock, Label, Value } from './index.styled'

const TseErstbestellung = React.memo(({ startTime }) => {
	const { t } = useTranslation()
	return (
		<TseErstbestellungBlock>
			<Label>{t('restaurant.tse.erstbestellung.label')}</Label>
			<Value>{formatTseDate(startTime)}</Value>
		</TseErstbestellungBlock>
	)
})

TseErstbestellung.displayName = 'TseErstbestellung'
export default TseErstbestellung
